import Vue from "vue";
import Router from "vue-router";

//Login
import UpointLogin from "./views/UpointLogin.vue";

//billImage
import BillImage from "./views/BillImage.vue";
//Login

import Login from "./views/Login.vue";

//Base Layout
import Content from "./views/layout/Content.vue";

//Transaction
import Transaction from "./views/transaction/List.vue";

//Transaction журмын халаас
import TransactionJuram from "./views/transactionJuram/List.vue";

// Transaction Хүүхдийн карт
import transactionChild from "./views/transactionChild/List.vue";

//Transaction Business
import TransactionBusiness from "./views/transactionBusiness/List.vue";

//TransactionBn
import TransactionBn from "./views/transactionBn/List.vue";

//businessBonus
import BusinessBonus from "./views/businessBonus/List.vue";

//Coin
import Coin from "./views/coin/List.vue";

//User
import User from "./views/user/User.vue";
import Forget from "./views/user/Forget.vue";
import CardRegister from "./views/user/CardRegister.vue";

//User Mobile
import MobileUserInfo from "./views/user/MobileUserInfo.vue";
import MobileUserEdit from "./views/user/MobileUserEdit.vue";
import MobileUserPassword from "./views/user/MobileUserPassword.vue";

//Member
import Service from "./views/service/List.vue";
//Member
import CardBusiness from "./views/CardBusiness/CardBusiness.vue";

import Member from "./views/member/List.vue";

//Tokyo
import Tokyo from "./views/tokyo/List.vue";

//Home
import HomeDashboard from "./views/home/HomeDashboard.vue";

//Bisiness Card
import BusinessCard from "./views/business/BusinessCard.vue";

//Bisiness Card
import BusinessHelp from "./views/business/BusinessHelp.vue";

import Otp from "./views/user/Otp.vue";
import GoogleWalletSignIn from "./views/googleWallet/GoogleWalletSignIn.vue";
import GoogleWalletSignUp from "./views/googleWallet/GoogleWalletSignUp.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/login/:id",
      name: "login",
      component: Login,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/google-wallet/sign-in",
      name: "signInGoogleWallet",
      component: GoogleWalletSignIn,
    },
    {
      path: "/google-wallet/sign-up",
      name: "signUpGoogleWallet",
      component: GoogleWalletSignUp,
    },
    {
      path: "/otp",
      name: "otp",
      component: Otp,
    },
    {
      path: "/b/:tokenId",
      name: "billImage",
      component: BillImage,
    },
    {
      path: "/forget",
      name: "forget",
      component: Forget,
    },
    {
      path: "/business",
      name: "business",
      component: BusinessCard,
    },
    {
      path: "/card-register",
      name: "card-register",
      component: CardRegister,
    },

    {
      path: "/businessHelp",
      name: "businessHelp",
      component: BusinessHelp,
    },

    {
      path: "/upoint",
      name: "upointLogin",
      component: UpointLogin,
    },
    {
      path: "/",
      component: Content,
      children: [
        {
          path: "/profile",
          component: User,
          meta: {
            requiresAuth: false,
          },
        },

        {
          path: "/",
          name: "homeDashboard",
          component: HomeDashboard,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/transaction",
          name: "transaction",
          component: Transaction,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/transactionJuram",
          name: "transactionJuram",
          component: TransactionJuram,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/transactionChild",
          name: "transactionChild",
          component: transactionChild,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/transactionBusiness",
          name: "transactionBusiness",
          component: TransactionBusiness,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/transactionBn",
          name: "transactionBn",
          component: TransactionBn,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/businessBonus",
          name: "businessBonus",
          component: BusinessBonus,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/service",
          name: "service",
          component: Service,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/CardBusiness",
          name: "CardBusiness",
          component: CardBusiness,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/info",
          name: "MobileUserInfo",
          component: MobileUserInfo,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/user-edit",
          name: "MobileUserEdit",
          component: MobileUserEdit,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/user-password",
          name: "MobileUserPassword",
          component: MobileUserPassword,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/coin",
          name: "coin",
          component: Coin,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/member",
          name: "member",
          component: Member,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/tokyo",
          name: "tokyo",
          component: Tokyo,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
});
